GP.vent.on("user:install_app", function(self) {

    // site opened in standalone mode
    // no need to show install app notice
    if (window.matchMedia('(display-mode: standalone)').matches) {
        return;
    }

    const close_toast = document.querySelector(".close-toast-wrap");
    const install_app_wrap = document.querySelector(".install-app-wrap");

    let pwaBeforeInstallPrompt = null;

    const showInstallNotice = () => {
        install_app_wrap.classList.add('shown');
        document.querySelector("body").classList.add('install-app-shown');
        GP.Util.set_cookie('fl_inst_app', 1, 7); // 7 days
    };    

    const handleToastClose = () => {
        install_app_wrap.classList.remove('shown');
        document.querySelector("body").classList.remove('install-app-shown');
        close_toast.removeEventListener("touchmove", handleToastClose, false);
        //refresh here to see if it helps
        window.location.href = window.location.href;
    };

    // show the install app prompt
    const handleInstallPrompt = () => {
        if (pwaBeforeInstallPrompt) {
            pwaBeforeInstallPrompt.prompt();
        }
    };

    const logAppInstall = () => {
        $.post('/members/admin/add_user_activity_stats', {
            stat: 'APP_INSTALL',
        }).done(function(json) {

        });
    };

    // install service worker
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/sw.js").then(function(registration) {

        }).catch(function(err) {
            console.log('ServiceWorker registration failed: ', err);
        });
    }

    close_toast.addEventListener("click", handleToastClose, false);
    document.querySelector(".btn-install-app").addEventListener("click", handleInstallPrompt, false);

    window.addEventListener('beforeinstallprompt', (event) => {
        // Prevents the default mini-infobar or install dialog from appearing on mobile
        event.preventDefault();

        pwaBeforeInstallPrompt = event;

        // prompt is ready. Show install notice.
        showInstallNotice();

        event.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                handleToastClose();
                logAppInstall();
            }
        });
    });
});


